import { render, staticRenderFns } from "./PriceCalculationListComponent.vue?vue&type=template&id=7320bfb2&"
import script from "./PriceCalculationListComponent.vue?vue&type=script&lang=js&"
export * from "./PriceCalculationListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports